









































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { Hospital } from '../store/types';
import MatchedInput from './matched-input.vue';

@Component({
  components: {
    MatchedInput,
  },
})
export default class extends Vue {
  @Prop({ default: null })
  public prediction!: any;

  private getSecondaryText(prediction: any) {
    return `${
      // @ts-ignore
      prediction.place_name
        ? // @ts-ignore
          // @ts-ignore
          ', ' + prediction.place_name
        : ''
    }`;
  }

  @Emit('click')
  private onClick() {
    return this.prediction;
  }
}
